// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import DatePicker from 'react-datepicker';
interface DateTimePickerProps {
    onChange: (dateTime: string) => void;
    value?: string;
    className?: string;
    dateTimeFormat?: string;
    id: string;
}

const parseDateTimeValue = (value?: string) => {
    if (!value) {
        return null;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatDateTimeValue = (value: Date | null) => {
    if (!value) {
        return '';
    }

    const year = value.getFullYear();
    const month = value.getMonth() + 1;
    const day = value.getDate();
    const hours = value.getHours();
    const minutes = value.getMinutes().toString().padStart(2, '0');
    const meridiem = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;

    return `${year}-${month}-${day} ${hour12}:${minutes} ${meridiem}`;
};

const DateTimePicker: React.FC<DateTimePickerProps> = ({
    className,
    dateTimeFormat,
    id,
    onChange,
    value,
}) => {
    const handleChange = (date: Date | null) => {
        onChange(formatDateTimeValue(date));
    };

    return (
        <DatePicker
            id={id}
            selected={parseDateTimeValue(value)}
            onChange={handleChange}
            showTimeSelect
            timeIntervals={30}
            dateFormat={dateTimeFormat || 'yyyy-M-d h:mm aa'}
            className={`datetime-picker ${className ? className : ''}`.trim()}
            wrapperClassName="datetime-picker-wrapper"
            calendarClassName="flux-datetime-calendar"
            popperClassName="datetime-picker-popup"
            popperPlacement="bottom-start"
            showPopperArrow={false}
            shouldCloseOnSelect={false}
            fixedHeight
            timeCaption="Time"
            autoComplete="off"
        />
    );
}

export default DateTimePicker;